import { IRewardQuery } from "../../models/reward/query";
import { IReward, IRewardDetails } from "../../models/reward/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, RewardLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: RewardLoading | RewardLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IReward> } }
  | { type: "SET_HISTORY"; payload: { history: IBaseListingResponse<any> } }
  | { type: "SET_DETAILS"; payload: { details?: IRewardDetails } }
  | QueryAction<IRewardQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }
    case "SET_HISTORY": {
      return {
        ...state,
        history: action.payload.history,
      };
    }
    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
